import { dictionary, Language } from "../../utils/dictionary";

interface PlatformIconProps {
  platform: string;
  language: Language;
}

const META_LABEL = "Meta";
const TIKTOK_LABEL = "TikTok";

export const PlatformIcon = ({ platform, language }: PlatformIconProps) => {
  const label =
    platform === "tiktok"
      ? TIKTOK_LABEL
      : platform === "meta"
        ? META_LABEL
        : dictionary["common-unknown"]?.[language] ?? "Unknown";

  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-gray-700">
      {platform === "meta" && (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#0866FF" aria-hidden="true">
          <path d="M12 2C6.48 2 2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95 0-5.52-4.48-10-10-10z" />
        </svg>
      )}
      {platform === "tiktok" && (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43V8.6a8.16 8.16 0 004.77 1.52V6.69h-1.84z" />
        </svg>
      )}
      <span>{label}</span>
    </span>
  );
};

export default PlatformIcon;
